// Professional Detail View Components
// A comprehensive set of components for creating professional, visually appealing detail pages

// Main container component
export {
  ProfessionalDetailView,
  default as ProfessionalDetailViewDefault,
} from './professional-detail-view';
export type { ProfessionalDetailViewProps, TabConfig } from './professional-detail-view';

// Hero header component
export { DetailHeroHeader } from './detail-hero-header';
export type { DetailHeroHeaderProps } from './detail-hero-header';

// Quick stats component
export { DetailQuickStats } from './detail-quick-stats';
export type { DetailQuickStatsProps, QuickStatItem } from './detail-quick-stats';

// Section component
export { DetailSection } from './detail-section';
export type { DetailSectionProps, AccentPosition, SectionVariant } from './detail-section';

// Info field component
export { DetailInfoField } from './detail-info-field';
export type { DetailInfoFieldProps, InfoFieldSize, InfoFieldLayout } from './detail-info-field';

// Info grid component
export { DetailInfoGrid } from './detail-info-grid';
export type { DetailInfoGridProps, InfoGridField } from './detail-info-grid';
